import 'application/src/scss/landingpage/rawmaterial/rawmaterial.scss';

import {
  flatUiPaletteV1
} from 'application/src/js/globals.js';

import {
  Mediator,
  SpinnerOverlay
} from 'application/src/js/util.js';

import {
  drawLimitLines,
  showTooltip
} from './functions.js';

import OffersAndRequests from './offers-and-requests/main.js';
import Cropdata from './cropdata/main.js';
import CropHistoryChart from './crop-history/main.js';
import Cropdates from './cropdates/main.js';
import NewsList from './news/main.js';
import Charts from './charts/main.js';
import Companies from './companies/main.js';
import VolumeMap from './cropdata/volume-map.js';
import TradeStatistics from './statistics/main.js';

window.addEventListener('DOMContentLoaded', _ => {
  moment.locale(selectedLanguage);

  const chartColors = [
    flatUiPaletteV1.peterRiver,
    flatUiPaletteV1.pumpkin,
    flatUiPaletteV1.amethyst,
    flatUiPaletteV1.greenSea,
    flatUiPaletteV1.alizarin,
    flatUiPaletteV1.sunFlower,
    flatUiPaletteV1.emerald,
    flatUiPaletteV1.orange,
    flatUiPaletteV1.turquoise,
    flatUiPaletteV1.asbestos,
    flatUiPaletteV1.nephritis,
  ];

  const loader = new SpinnerOverlay({
    targetContainer: document.querySelector('.lp-content'),
    position: 'fixed',
    visible: true
  });

  const mediator = new Mediator();

  // ensures that the loader shows when the first request
  // is fired and hides after ALL requests completed
  let runningLoadingProcesses = 0;
  mediator.subscribe('startedLoading', _ => {
    runningLoadingProcesses++;
    if (runningLoadingProcesses === 1) loader.show();
  });
  mediator.subscribe('finishedLoading', _ => {
    runningLoadingProcesses--;
    if (runningLoadingProcesses === 0) loader.hide();
  });

  new NewsList({
    rawmaterialid: rawmaterialid,
    loader: loader,
    translations: translations.landingpage.news,
    mediator: mediator
  });

  new OffersAndRequests({
    rawmaterialid: rawmaterialid,
    loader: loader,
    translations: {
      offers: translations.landingpage.offers,
      requests: translations.landingpage.requests
    },
    mediator: mediator
  });

  new Cropdata({
    rawmaterialid: rawmaterialid,
    loader: loader,
    translations: translations.landingpage.cropdata,
    mediator: mediator,
    map: new VolumeMap({
      rawmaterialid: rawmaterialid,
      loader: loader,
      translations: translations.landingpage.map,
      mediator: mediator
    })
  });

  new CropHistoryChart({
    rawmaterialid: rawmaterialid,
    loader: loader,
    colors: chartColors,
    translations: translations.landingpage.charts,
    drawLimitLines: drawLimitLines,
    showTooltip: showTooltip,
    mediator: mediator
  });

  new Cropdates({
    rawmaterialid: rawmaterialid,
    loader: loader,
    translations: translations.landingpage.cropdates,
    mediator: mediator
  });

  new Charts({
    rawmaterialid: rawmaterialid,
    loader: loader,
    colors: chartColors,
    translations: translations.landingpage.charts,
    drawLimitLines: drawLimitLines,
    showTooltip: showTooltip,
    mediator: mediator
  });

  new Companies({
    rawmaterialid: rawmaterialid,
    loader: loader,
    translations: translations.landingpage.addresses,
    mediator: mediator
  });

  new TradeStatistics({
    rawmaterialid: rawmaterialid,
    selectedLanguage: selectedLanguage
  });
});